import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BooleanSelectEditViewSpacer = styled.div({
	margin: `10px 0 ${token('space.025', '2px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DatePickerEditViewSpacer = styled.div({
	margin: `${token('space.050', '4px')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GroupPickerEditViewSpacer = styled.div({
	margin: `${token('space.150', '12px')} 0 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ProjectPickerEditViewSpacer = styled.div({
	margin: `${token('space.150', '12px')} 0 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ReferencedObjectPickerEditViewSpacer = styled.div({
	margin: `${token('space.150', '12px')} 0 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SelectEditViewSpacer = styled.div({
	margin: `${token('space.150', '12px')} 0 ${token('space.050', '4px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BitbucketRepoPickerEditViewSpacer = styled.div({
	margin: `${token('space.150', '12px')} 0 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StatusPickerEditViewSpacer = styled.div({
	margin: `${token('space.150', '12px')} 0 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EditViewSpacers = {
	BooleanSelect: BooleanSelectEditViewSpacer,
	DatePicker: DatePickerEditViewSpacer,
	GroupPicker: GroupPickerEditViewSpacer,
	ProjectPicker: ProjectPickerEditViewSpacer,
	ReferencedObjectPicker: ReferencedObjectPickerEditViewSpacer,
	Select: SelectEditViewSpacer,
	BitbucketRepoPicker: BitbucketRepoPickerEditViewSpacer,
	StatusPicker: StatusPickerEditViewSpacer,
} as const;
